<template>
    <dap-popover placement="top" trigger="hover" :disabled="!option.tip" :content="option.tip">
    <div slot="reference" class="dap-filter-bar f12 flex-normal m-b-10 m-r-10" :style="{height: `${height}px`, lineHeight: `${height}px`,}"
        v-if="!hide && option && !option.hideRes" :class="{other: option.type === 'other', disabled: option.disabled}">
            <!-- <template slot="reference"> -->
        <div class="c-333 left-area f12 text-ellipsis">
            <span class="c-999 bar-title">{{ getName }}:</span>
            <span v-if="!['multiModal'].includes(option.type)" :title="getValue">{{ getValue }}</span>
            <span v-else>已{{ excludeSelected ? '排除' : '选' }}{{ (selected || []).length }}项</span>
        </div>
        <div class="c-999 right-area f12 flex-center" :title="getValue">
            <div v-if="option.type === 'multi'" class="m-r-3 multi-plus" style="border-radius: 2px">
                <div class="multi-plus-content">+{{ (selected || []).length }}</div>
            </div>
            <div v-if="['singleModal', 'multiModal'].includes(option.type) && !option.disabled"
                class="m-r-5" style="color: #4284F4"
                :class="{'choose-text': clearable}">选择</div>
            <i class="el-icon-arrow-down f12" v-if="['single', 'multi'].includes(option.type) && !option.disabled"
            :class="{'can-change-arrow': clearable}"></i>
            <i class="el-icon-error f12" @click.stop="removeResult" v-if="clearable && !option.disabled"
            :class="[['single', 'multi', 'multiModal'].includes(option.type) && 'can-change-error']"></i>
        </div>
            <!-- </template> -->
        <div class="selector-area">
            <el-select
                v-if="option.type === 'single'" popper-class="global-filter-select-popper"
                class="pull-left" v-model="selected" style="width: 100%;"
                :value-key="propsMapper.value" :disabled="option.disabled" :size="size"
            >
                <el-option
                    v-for="item in option.dataList" :key="item[propsMapper.value]" :value="item"
                    :label="item[propsMapper.label]"
                ></el-option>
            </el-select>

            <DapMultiSelectPull
                v-if="option.type === 'multi'" ref="multiSelect" style="width: 100%" :size="size"
                v-bind="option" :resultList="selected || []" hideInput :width="135" content-width="200"
                @change="handleChangeSelect">
            </DapMultiSelectPull>

            <MultiSelectBarForFilter
                v-if="option.type === 'multiModal'" ref="multiSelect" :size="size" :title="option.name"
                v-bind="option" :filterOption="option" :resultList="selected || []" hideInput :width="135"
                :excludeSelected="excludeSelected"
                @change="handleChangeSelect">
            </MultiSelectBarForFilter>

            <DapPopover
                v-if="option.type === 'metric'" :title="option.name" confirmable popper-class="metric-popover"
                placement="bottom-start"
                @cancel="handlePopoverCancel" @show="handleShowPopover"
                @confirm="handlePopoverConfirm"
            >
                <el-form :model="metricResult" class="flex-normal" ref="form">
                    <el-select
                        size="mini" popper-class="global-filter-select-popper w90" class="m-r-6 operation-select w90"
                        v-model="metricResult.operation" @change="handleChangeOperation">
                        <el-option
                            v-for="operation in getOperationList(option.operations)" :key="operation.key"
                            :value="operation.value" :label="operation.label"
                        />
                    </el-select>
                    <el-form-item
                        v-if="metricResult.operation !== 'BETWEEN'"
                        prop="value" style="margin-bottom: 0"
                        :rules="[{required: true, message: '请输入指标'}]"
                    >
                        <el-input v-model="metricResult.value" size="mini" style="width: 204px">
                            <span slot="suffix">{{option.unit}}</span>
                        </el-input>
                    </el-form-item>
                    <div v-else class="range-input flex-normal f12">
                        <el-form-item
                            prop="value" style="margin-bottom: 0"
                            :rules="[{required: true, message: '请输入指标'}]"
                        >
                            <el-input v-model="metricResult.value" size="mini" class="w90 no-border">
                            </el-input>
                        </el-form-item>
                        <div class="c-333 m-l-2 m-r-2 f12">-</div>
                        <el-form-item
                            prop="value2" style="margin-bottom: 0"
                            :rules="[{required: true, message: '请输入指标'}]"
                        >
                            <el-input v-model="metricResult.value2" size="mini" class="w90 no-border">
                            </el-input>
                        </el-form-item>
                        <div class="c-ccc m-r-4">{{option.unit}}</div>
                    </div>
                </el-form>
                <div style="width: 100%; height: 100%;opacity: 0" slot="reference" :title="getValue">.</div>
            </DapPopover>

        </div>
    </div>
    </dap-popover>
</template>

<script>
import DapMultiSelectPull from '../../../base-selector/src/MultiSelectPull';
import MultiSelectBarForFilter from './MultiSelectBarForFilter';

export default {
    name: 'FilterBar',
    components: {
        DapMultiSelectPull,
        MultiSelectBarForFilter,
    },
    props: {
        hide: {
            type: Boolean,
            default: false,
        },
        selectKey: {
            type: String,
            default: '',
        },
        size: {
            type: String,
            default: 'mini',
        },
        overrideSearchMapper: {
            type: Object,
        }
    },
    data () {
        return {
            metricResult: {},
            filterItem: {}
        };
    },
    inject: {
        parentOptions: 'options',
        parentResult: 'result',
        parentFilterData: 'filterData',
        operationList: 'operationList',
        getExcludeValue: 'excludeSelectedItems',
        getUnremoveKeys: 'unremoveKeys'
    },
    computed: {
        options () {
            return this.parentOptions();
        },
        filterData () {
            return this.parentFilterData();
        },
        unremoveKeys () {
            return this.getUnremoveKeys();
        },
        option () {
            // console.log(this.selectKey);
            if (this.options.search) {
                const res = this.options.search.find(i => i.key === this.selectKey);
                if (res) {
                    return { ...res, type: 'text' };
                }
                if (this.selectKey === this.overrideSearchMapper.search) {
                    const res = this.options.search.find(i => i.key === this.filterData[this.overrideSearchMapper.searchType]);
                    if (res) {
                        return { ...res, type: 'text'};
                    }
                }
            }
            if (this.options.metrics) {
                for (let metricGroup of this.options.metrics) {
                    const res = metricGroup.children.find(i => i.key === this.selectKey)
                    if (res) {
                        // console.log(res);
                        return { ...res, type: 'metric' };
                    }
                }
            }
            if (this.options.others) {
                const res = this.options.others.find(i => i.key === this.selectKey);
                if (res) {
                    return { ...res, type: 'other' };
                }
            }
            const subOptionsList = this.options.filters.reduce((res, item) => [...item.children, ...res], []);
            const res = subOptionsList.find(i => i.key === this.selectKey);
            return res || '';
        },
        propsMapper () {
            return this.option.propsMapper || { value: 'value' , label: 'label' };
        },
        selected: {
            get () {
                return this.parentResult()[this.selectKey];
            },
            set (val) {
                this.$emit('setResult', { [this.option.key]: val});
            }
        },
        isMulti () {
            return ['multi', 'multiModal'].includes(this.option.type);
        },
        getName () {
            return this.option.name;
        },
        getValue () {
            if (this.option.type === 'metric') {
                let resStr = this.operationList.find(i => this.selected.operation === i.value).label + this.selected.value;
                if (this.selected.value2) {
                    resStr += `-${this.selected.value2}`;
                }
                return resStr + this.option.unit;
            }
            const mapper = this.option.propsMapper || { value: 'value', label: 'label'};
            if (typeof this.selected === 'string') {
                return this.selected;
            } else if (this.isObj(this.selected)) {
                return this.selected[mapper.label];
            } else if (Array.isArray(this.selected)) {
                if (this.selected.length === 0) {
                    return '不限';
                }
                return this.selected.map(i => i[mapper.label]).join(',');
            }
            return '未知类型';
        },
        clearable () {
            return this.option.clearable === true || this.option.clearable === undefined && !this.unremoveKeys.includes(this.option.key);
        },
        height () {
            return {
                mini: 28,
                small: 32,
            }[this.size];
        },
        excludeSelected () {
            const filterItem = this.getFilterItem();
            return this.getExcludeValue()[filterItem.excludeSelectedKey] || false;
        },
    },
    methods: {
        getFilterItem () {
            const subOptionsList = this.options.filters.reduce((res, item) => [...item.children, ...res], []);
            return subOptionsList.find(i => i.key === this.selectKey) || {};
        },
        isObj (obj) {
            return Object.prototype.toString.call(obj) === '[object Object]';
        },
        removeResult () {
            this.$emit('removeResult', this.selectKey);
        },
        handleChangeSelect (res, exclude) {
            const filterItem = this.getFilterItem();
            console.log(this.option);
            this.$emit('setResult', { [this.option.key]: res}, filterItem.excludeSelectedKey, exclude);
        },
        handleShowPopover () {
            this.metricResult = JSON.parse(JSON.stringify(this.selected));
        },
        handlePopoverConfirm () {
            this.$refs.form.validate().then(res => {
                this.$emit('setResult', { [this.option.key]: this.metricResult});
                this.handlePopoverCancel();
            })
        },
        handlePopoverCancel () {
            window.document.body.click()
        },
        handleChangeOperation () {
            this.metricResult.value = '';
            this.metricResult.value2 = '';
        },
        getOperationList (operations) {
            const realOperations = operations || ['GREATER_THAN_EQUAL', 'LESS_THAN_EQUAL', 'EQUALS', 'BETWEEN'];
            return this.operationList.filter(i => realOperations.includes(i.value));
        },
    }
};
</script>

<style lang="scss">
.dap-filter-bar {
    display: inline-flex;
    white-space: normal;
    /*background-color: rgba(65, 133, 244, 0.25);*/
    background-color: #fff;
    border-radius: 3px;
    padding: 0 5px 0 8px;
    width: 155px;
    cursor: pointer;
    position: relative;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;
    &:hover:not(.disabled) {
        border-color: #4284F4;
    }

    i {
        color: #999999;
    }

    &.disabled {
        cursor: not-allowed;
    }


    .selector-area {
        position: absolute;
        left: 0;
        top: 0;
        width: calc(100% - 22px);
        .el-select {
            .el-input {
                opacity: 0;
            }
        }
    }

    .left-area {
        flex: auto;
        overflow: hidden;
        position: relative;
    }

    .right-area {
        display: flex;
        flex-wrap: nowrap;
        white-space: nowrap;
        align-items: center;
        .multi-plus {
            color: #606266;
            .multi-plus-content {
                line-height: 20px;
                padding: 0 2px;
                border-radius: 2px;
                background-color: #F4F4F5;
            }
        }
    }

    .el-icon-error {
        height: 26px;
        line-height: 26px;
        &.can-change-error {
            display: none;
        }
    }

    &:hover {

        .el-icon-arrow-down.can-change-arrow, .choose-text {
            display: none;
        }

        .el-icon-error {
            display: inline-block;
        }
    }
}

.pop-menu {
    max-height: 320px;
    width: 100%;
    overflow-x: auto;
}
</style>
